// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"fa68ec9e","143":"2b244ad0","488":"7307908c","565":"2f468ad8","681":"a8fbdbf0"}[chunkId] + ".chunk.js";
};